import router from '../router/index';
import store from '../store/index';
import userDataApi from '../api/userData';

export default {
    logout: () => {
        // Send logout request to BE
        userDataApi.logout();

        // Clear local storage
        localStorage.setItem('login', 0);
        localStorage.clear();
        
        // Clear Vuex store
        store.dispatch('userData/resetStoreModuleData');
        store.dispatch('projects/resetStoreModuleData');
        store.dispatch('system/resetStoreModuleData');
        
        // Redirect user to 'login'
        router.push({name: 'login'});
    }
}